import { useSendSmsCode } from 'features/registration/hooks/useSendSmsCode';
import { RegistrationFormData } from 'features/registration/interface/registration';
import { FormikErrors, FormikTouched } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

interface SendCodeProps {
	isFieldValueValid: any;
	errors: FormikErrors<{ [field: string]: any }>;
	touched: FormikTouched<{}>;
	values: RegistrationFormData;
	setDialogType: any;
	cyTestRef: string;
}
export const SendCode = (props: SendCodeProps) => {
	const { isFieldValueValid, errors, touched, values, setDialogType } = props;
	const { t } = useTranslation();
	const [isSending, setIsSending] = useState(false);
	const { sendCode } = useSendSmsCode(setDialogType);

	return (
		<div
			className="sendCode"
			onClick={() => {
				if (isFieldValueValid('phoneNum', errors, touched)) {
					return;
				}
				setIsSending(true);
				const code = sendCode(values.email, values.emailConsent, values.phoneNum, values.smsConsent);

				code.then(() => {
					setIsSending(false);
				});
			}}
			data-cy={props.cyTestRef}
		>
			{isSending ? t('sendCodeAwait') : t('sendCodeAgain')}
		</div>
	);
};

export default SendCode;
